import { Grid, FormControl, TextField, Button, SvgIcon, useTheme } from '@mui/material';
import { Box } from '@mui/system';

import { SearchSm } from '../../../assets';
import { useContext } from 'react';
import { CreateInvoicesValues, InvoicesContext } from '../contexts/InvoicesContext';
import { InvoiceTable } from './InvoiceTable';
import { Section } from '../../../components/ui/Section';
import DatePickerLocalized from '../../../components/shared/DatePickerLocalized';
import dayjs from 'dayjs';

export const InvoiceBox = () => {

  const { t, invoiceNumber, handleInvoiceNumberChange, handleEndDateChange, orderNumber, handleClearAllClick, handleOrderNumberChange, startDate, endDate, loadData, handleStartDateChange } = useContext(InvoicesContext) as CreateInvoicesValues;
  const theme = useTheme();

  return <Box sx={{ pt: '6px' }}>
    <Grid container
      spacing={5}>
      <Grid item
        sm={3}
        xs={6}>
        <FormControl fullWidth>
          <TextField label={t('invoiceNumber')}
            value={invoiceNumber}
            onChange={handleInvoiceNumberChange} />
        </FormControl>
      </Grid>
      <Grid item
        sm={3}
        xs={6}>
        <FormControl fullWidth>
          <TextField label={t('orderNumber')}
            value={orderNumber}
            onChange={handleOrderNumberChange} />
        </FormControl>
      </Grid>
      <Grid item
        sm={3}
        xs={6}>
        <FormControl fullWidth>
          <DatePickerLocalized
            useCalendar={false}
            label={t('startDate')}
            value={startDate}
            maxDate={dayjs(endDate)}
            onChange={handleStartDateChange} />
        </FormControl>
      </Grid>
      <Grid item
        sm={3}
        xs={6}>
        <FormControl fullWidth>
          <DatePickerLocalized
            useCalendar={false}
            label={t('endDate')}
            value={endDate}
            minDate={dayjs(endDate)}
            onChange={handleEndDateChange} />
        </FormControl>
      </Grid>
      <Grid item
        sm={3}
        xs={6}>
        <Button
          fullWidth
          variant="secondary"
          size="lg"
          onClick={handleClearAllClick}
        >
          {t('clearAll')}
        </Button>
      </Grid>
      <Grid item
        sm={3}
        xs={6}>
        <Button
          fullWidth
          variant="primary"
          size="lg"
          startIcon={<SvgIcon> <SearchSm /> </SvgIcon>}
          onClick={loadData}
        >
          {t('search')}
        </Button>
      </Grid>
      <Grid item
        xs={12}>
        <Section>
          <InvoiceTable></InvoiceTable>
        </Section>
      </Grid>
    </Grid>
  </Box>;
};